// extracted by mini-css-extract-plugin
export default {"property":"style_property__k56p3"};